import React from 'react';
import { Card, CardContent, Typography, IconButton, Table, TableBody, TableCell, TableRow, TableHead } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const WalkChartBox = ({ onClose, deviceId, beatData }) => {
  return (
    <Card
      sx={{
        position: 'absolute',
        top: 100,
        left: 100,
        zIndex: 1000,
        width: 400,
        boxShadow: 6,
        borderRadius: 2,
        backgroundColor: 'white',
      }}
    >
      <CardContent>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" fontWeight="bold">
            Beat Details <span style={{ fontWeight: 'normal' }}>{deviceId}</span>
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>

        <Table size="small" sx={{ mt: 1 }}>
          <TableHead>
            <TableRow>
              <TableCell align="center"><strong>Trip Start Beat</strong></TableCell>
              <TableCell align="center"><strong>Trip End Beat</strong></TableCell>
              <TableCell align="center"><strong>Start Time</strong></TableCell>
              <TableCell align="center"><strong>End Time</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {beatData.map((row, index) => (
              <TableRow key={index}>
                <TableCell align="center">{row.startBeat}</TableCell>
                <TableCell align="center">{row.endBeat}</TableCell>
                <TableCell align="center">{row.startTime}</TableCell>
                <TableCell align="center">{row.endTime}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default WalkChartBox;
